import { render, staticRenderFns } from "./ShiftsHeader.vue?vue&type=template&id=5dad6b4a&lang=pug"
import script from "./ShiftsHeader.vue?vue&type=script&lang=js"
export * from "./ShiftsHeader.vue?vue&type=script&lang=js"
import style0 from "./ShiftsHeader.vue?vue&type=style&index=0&id=5dad6b4a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports